import { declOfNum } from '@ertelecom/ui-react/components/helpers';

export const day = declOfNum(['день', 'дня', 'дней']);
export const rub = declOfNum(['рубль', 'рубля', 'рублей']);
export const raz = declOfNum(['раз', 'раза', 'раз']);
export const tryStr = declOfNum(['попытка', 'попытки', 'попыток']);
export const channel = declOfNum(['канал', 'канала', 'каналов']);
export const month = declOfNum(['месяц', 'месяца', 'месяцев']);
